import * as constants from './constants';
import {get, post} from "../../../utils/request";
import {ORDER_LIST,REFUND_URL} from '../../../utils/api';

export const OrderList = (Entity) => ({
    type: constants.ORDER_LIST,
    value: Entity
});

export const getOrderList = (params) => {
    return (dispatch) => {
        return post(ORDER_LIST, params)
            .then((response) => {
                return dispatch(OrderList(response.data));
            });
    }
};


export const refund = (params) => {
    return async () => {
        const result = await post(REFUND_URL, params);
        return result;
    }
}